import { Modal, Pressable } from "react-native";
import styled from "styled-components/native";
import { colors, radius, font } from "@/lib/theme";
import { ModalContent } from "@/components/ContentWidth";

interface AlertSheetProps {
  visible: boolean;
  title: string;
  message?: string;
  emoji?: string;
  buttonLabel?: string;
  buttonColor?: string;
  onClose: () => void;
}

const Sheet = styled.View`
  background-color: ${colors.white};
  border-top-left-radius: ${radius.xl}px;
  border-top-right-radius: ${radius.xl}px;
  padding: 24px;
  padding-bottom: 40px;
  align-items: center;
`;

const Emoji = styled.Text`
  font-size: 40px;
  margin-bottom: 12px;
`;

const Title = styled.Text`
  font-size: 18px;
  font-weight: ${font.extrabold};
  color: ${colors.ink};
  text-align: center;
  margin-bottom: 8px;
`;

const Message = styled.Text`
  font-size: 14px;
  color: ${colors.inkSecondary};
  text-align: center;
  line-height: 20px;
  margin-bottom: 20px;
`;

const CloseBtn = styled.View<{ btnColor?: string }>`
  background-color: ${(p) => p.btnColor || colors.brand};
  border-radius: ${radius.card}px;
  padding: 16px;
  align-items: center;
  width: 100%;
`;

const CloseBtnText = styled.Text`
  color: #fff;
  font-size: 16px;
  font-weight: ${font.bold};
`;

export default function AlertSheet({
  visible,
  title,
  message,
  emoji,
  buttonLabel = "OK",
  buttonColor,
  onClose,
}: AlertSheetProps) {
  return (
    <Modal visible={visible} animationType="slide" transparent>
      <ModalContent onClose={onClose}>
        <Sheet>
          {emoji && <Emoji>{emoji}</Emoji>}
          <Title>{title}</Title>
          {message && <Message>{message}</Message>}
          <Pressable onPress={onClose} style={({ pressed }) => ({ width: "100%" as any, opacity: pressed ? 0.9 : 1 })}>
            <CloseBtn btnColor={buttonColor}>
              <CloseBtnText>{buttonLabel}</CloseBtnText>
            </CloseBtn>
          </Pressable>
        </Sheet>
      </ModalContent>
    </Modal>
  );
}
